export default __webpack_public_path__ + "images/1dafc0e15ddf57e1c335e6b155930770-federal_government_small.webp";